import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoUserAttribute
} from "amazon-cognito-identity-js";
import { Config, CognitoIdentityCredentials } from "aws-sdk";

export default class Cognito {
  configure(config) {
    if (config.userPool) {
      this.userPool = config.userPool;
    } else {
      this.userPool = new CognitoUserPool({
        UserPoolId: config.UserPoolId,
        ClientId: config.ClientId,
        Storage: sessionStorage
      });
    }
    Config.region = config.region;
    Config.credentials = new CognitoIdentityCredentials({
      IdentityPoolId: config.IdentityPoolId
    });
    this.options = config;
  }

  getToken() {
    let idkey = `CognitoIdentityServiceProvider.${this.userPool.clientId}.LastAuthUser`;
    let userid = this.userPool.storage[idkey];
    return this.userPool.storage[
      `CognitoIdentityServiceProvider.${this.userPool.clientId}.${userid}.idToken`
    ];
  }
  getUserId() {
    let idkey = `CognitoIdentityServiceProvider.${this.userPool.clientId}.LastAuthUser`;
    return this.userPool.storage[idkey];
  }
  static install = (Vue, options) => {
    Object.defineProperty(Vue.prototype, "$cognito", {
      get() {
        return this.$root._cognito;
      }
    });

    Vue.mixin({
      beforeCreate() {
        if (this.$options.cognito) {
          this._cognito = this.$options.cognito;
          this._cognito.configure(options);
        }
      }
    });
  };

  signUp(username, password) {
    const dataEmail = { Name: "email", Value: username };
    const attributeList = [];

    // username=emailなので不要だが後々のため消さないでおく
    attributeList.push(new CognitoUserAttribute(dataEmail));

    return new Promise((resolve, reject) => {
      this.userPool.signUp(
        username,
        password,
        attributeList,
        null,
        (err, result) => {
          if (err) {
            reject(err);
          } else {
            resolve(result);
          }
        }
      );
    });
  }

  confirmation(username, confirmationCode) {
    const userData = {
      Username: username,
      Pool: this.userPool,
      Storage: sessionStorage
    };
    const cognitoUser = new CognitoUser(userData);
    return new Promise((resolve, reject) => {
      cognitoUser.confirmRegistration(confirmationCode, true, (err, result) => {
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      });
    });
  }

  login(username, password) {
    console.log("login");
    const userData = {
      Username: username,
      Pool: this.userPool,
      Storage: sessionStorage
    };
    const self = this;
    const cognitoUser = new CognitoUser(userData);
    const authenticationData = { Username: username, Password: password };
    const authenticationDetails = new AuthenticationDetails(authenticationData);
    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: result => {
          resolve();
        },
        onFailure: err => {
          reject(err);
        }
      });
    });
  }

  /**
   * ログアウト
   */
  logout() {
    this.userPool.getCurrentUser().signOut();
  }

  /**
   * ログインしているかの判定
   */
  isAuthenticated() {
    const cognitoUser = this.userPool.getCurrentUser();
    return new Promise((resolve, reject) => {
      if (cognitoUser === null) {
        reject(cognitoUser);
      }
      cognitoUser.getSession((err, session) => {
        if (err) {
          reject(err);
        } else {
          if (!session.isValid()) {
            reject(session);
          } else {
            resolve(session);
          }
        }
      });
    });
  }

  forgetPassword(email) {
    const userData = {
      Username: email,
      Pool: this.userPool,
      Storage: sessionStorage
    };

    const cognitoUser = new CognitoUser(userData);
    return new Promise((resolve, reject) => {
      cognitoUser.forgotPassword({
        onSuccess: result => {
          console.log("email verification success");
          resolve(result);
        },
        onFailure: err => {
          console.log("email verification failed");
          reject(err);
        }
      });
    });
  }

  resetPassword(username, newPassword, code) {
    const userData = {
      Username: username,
      Pool: this.userPool,
      Storage: sessionStorage
    };
    const cognitoUser = new CognitoUser(userData);
    return new Promise((resolve, reject) => {
      cognitoUser.confirmPassword(code, newPassword, {
        onSuccess: result => {
          console.log("password reset success");
          resolve(result);
        },
        onFailure: err => {
          console.log("password reset failed");
          reject(err);
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/cognito/cognito.js